/**
 * Unwraps an order entity from common API response shapes:
 * `{ data: { order } }`, `{ data: orderLike }`, or a raw order object.
 */
export function unwrapOrderFromApiResponse(response: any): any {
  if (response == null || typeof response !== 'object') {
    return response;
  }
  const r = response as Record<string, any>;
  const data = r['data'];
  if (data != null && typeof data === 'object') {
    const d = data as Record<string, any>;
    const order = d['order'];
    if (order != null) {
      return order;
    }
    return data;
  }
  return response;
}
